import { defineMessages } from 'react-intl';

export default defineMessages({
    yesModal: {
       id: 'tfpa.quoteandbind.views.additionalInsured.Yes',
       defaultMessage: 'Yes'
    },
    noModal: {
       id: 'tfpa.quoteandbind.views.additionalInsured.No',
       defaultMessage: 'No'
    },
    saveFailedMsg: {
        id: 'tfpa.quoteandbind.views.additionalInsured.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'tfpa.quoteandbind.views.additionalInsured.Cannot Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    cancel: {
       id: 'tfpa.quoteandbind.views.additionalInsured.Cancel',
       defaultMessage: 'Cancel'
    },
    removeAdditionalInsured: {
       id: 'tfpa.quoteandbind.views.additionalInsured.Remove Additional Interest',
       defaultMessage: 'Remove Additional Insured?'
    },
    removeAddlInsuredMessage: {
       id: 'tfpa.quoteandbind.views.additionalInsured.Are you sure you want to remove this contact?',
       defaultMessage: ' Are you sure you want to remove this item?'
    },
   wantToDelete: {
      "id": "tfpa.quoteandbind.views.wantToDelete",
      "defaultMessage": "Remove Roofing Update"
   },
   roofingCancelMessage: {
      "id": "tfpa.quoteandbind.views.ancelMessage",
      "defaultMessage": "Are you sure you want to remove this roofing update?"
   },
   individualTiltle: {
      id: 'tfpa.quoteandbind.views.additionalInsured.Individual',
      defaultMessage: 'Individual',
  },
  estateTitle: {
      id: 'tfpa.quoteandbind.views.additionalInsured.Estate/Trust',
      defaultMessage: 'Estate/Trust',
  },

});
